import service1 from "../../Assets/img/service1.png";
import service2 from "../../Assets/img/service2.png";
import service3 from "../../Assets/img/service3.png";
import service4 from "../../Assets/img/service4.png";
import service5 from "../../Assets/img/service5.png";
import service6 from "../../Assets/img/service6.png";


const ServicesData =  [
    {
        id:1,
        img:service1,
        head:'Power washing',
        subtitle:'Revitalize exteriors with the power of high-pressure cleaning.',
        link:'/services/power-washing'
    },
    {
        id:2,
        img:service2,
        head:' Chandeliers Cleaning',
        subtitle:'Let your chandeliers shine like new with our expert cleaning services.',
        link:'/services/chandelier-cleaning'
    },
    {
        id:3,
        img:service3,
        head:'Deep cleaning',
        subtitle:'Restore freshness and cleanliness with our meticulous deep cleaning service.',
        link:'/services/deep-cleaning'
    },
    {
        id:4,
        img:service4,
        head:'Commercial carpet cleaning',
        subtitle:"Elevate your business's image with our professional commercial cleaning solutions.",
        link:'/services/commercial-carpet-cleaning'
    },
    {
        id:5,
        img:service5,
        head:'Basic cleaning',
        subtitle:'Efficient and thorough, our basic cleaning keeps your space tidy and inviting.',
        link:'/services/basic-cleaning'
    },
    {
        id:6,
        img:service6,
        head:'Remodel cleanup',
        subtitle:'Our remodel clean-up service takes the hassle out of cleaning up after construction or renovations.',
        link:'/services/remodel-cleanup'
    },
]

export default ServicesData;